// src/features/orders/components/OrderStatusBadge.tsx
import type { OrderStatus } from '../types/order.types';

export interface OrderStatusBadgeProps {
  status: OrderStatus;
}

const STATUS_LABEL: Record<string, string> = {
  pending: 'در انتظار پرداخت',
  paid: 'پرداخت شده',
  rejected: 'رد شده',
  deleted: 'حذف شده',
  expired: 'منقضی شده',
  cancelled: 'لغو شده',
};

const STATUS_COLOR_VAR: Record<string, string> = {
  pending: 'var(--vania-accent-amber, #f5b942)',
  paid: 'var(--vania-accent-teal, #2fd6a7)',
  rejected: 'var(--vania-accent-rose, #ff6b81)',
  deleted: 'var(--vania-accent-rose, #ff6b81)',
  expired: 'var(--vania-accent-rose, #ff6b81)',
  cancelled: 'var(--vania-accent-rose, #ff6b81)',
};

/**
 * Small pill badge mapping an order's raw status to its Persian label
 * + accent color. Same shape/markup as
 * services/components/ServiceStatusBadge.tsx (label map + color-var
 * map keyed by the union type) — kept local to this feature since the
 * status union (pending/paid/completed/failed/cancelled) is
 * order-specific.
 */
export function OrderStatusBadge({ status }: OrderStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status] ?? 'var(--vania-text-tertiary, #8a909c)';

  return (
    <span className="vania-order-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-order-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
